import { useState, useEffect, useCallback } from 'react';
import apiClient from '../utils/api';

/**
 * Connection status for any device provider on the generic device layer
 * (GET /api/auth/device/{provider}/status). Generalizes useFitbitStatus for
 * Oura and future providers; Fitbit stays on its legacy hook until convergence.
 */
export const useDeviceStatus = (provider) => {
  const [deviceStatus, setDeviceStatus] = useState({ connected: false, connected_at: null });
  const [loading, setLoading] = useState(true);

  const fetchStatus = useCallback(async () => {
    try {
      setLoading(true);
      const response = await apiClient.get(`/api/auth/device/${provider}/status`);
      if (response.status === 200) {
        setDeviceStatus(response.data);
      }
    } catch (error) {
      console.error(`Error fetching ${provider} status:`, error);
      setDeviceStatus({ connected: false, connected_at: null });
    } finally {
      setLoading(false);
    }
  }, [provider]);

  useEffect(() => {
    fetchStatus();

    // Refresh when the tab regains focus (e.g. returning from the OAuth redirect).
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        fetchStatus();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [fetchStatus]);

  return { deviceStatus, loading, refetch: fetchStatus };
};
